export default "__VITE_PUBLIC_ASSET__cc44b3ae__"